export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    /**
     * @param {object} props
     * @param {string} props.content
     * @param {grapesjs.Component} props.component
     * @param {string} [props.class]
     * @param {function|boolean} [isVisible=true]
     */
    styleManager.addType(window.PMW.emails.styles.ID_INFO_BOX, {
        create({props}) {
            props.component = props.component || editor.getSelected();
            let isVisible = true;

            if (props.hasOwnProperty('isVisible')) {
                isVisible = typeof props.isVisible === 'function' ? props.isVisible(editor, props.component) : props.isVisible;

                // hide parent container to avoid redundant margin
                if (!isVisible) {
                    $(`.gjs-sm-${props.type}`).addClass('_hidden');
                }
            }

            const infoClass = props.class || '',
                container = document.createElement('div'),
                visibilityClass = isVisible ? '' : '_hidden';

            container.className = `${props.type} info-wrapper ${infoClass} ${visibilityClass}`;
            container.innerHTML = `<div class="info-box">
                    <div class="body-xs info-message">
                        ${props.content}
                    </div>
                </div>`;

            return container;
        },
    });
}